export enum PlanFeature {
  DataDashboard = 'plans.features.dataDashboard',
  AdminDashboard = 'plans.features.adminDashboard',
  OrderManagement = 'plans.features.orderManagement',
  OrderTracking = 'plans.features.orderTracking',
  BarcodeReader = 'plans.features.barcodeReader',
  Notifications = 'plans.features.notifications',
  PackageRecords = 'plans.features.packageRecords',
  ProviderClientsManagement = 'plans.features.providerClientsManagement',
  PackageLabelPrinting = 'plans.features.packageLabelPrinting',
  QrReader = 'plans.features.qrReader',
  MapDisplay = 'plans.features.mapDisplay',
  ExportData = 'plans.features.exportData',
  ClientIntegration = 'plans.features.clientIntegration',
}
